import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable, map } from 'rxjs';
import { ConvivaApi } from 'src/app/conviva-api';
import { environment } from 'src/environments/environment';
import { DefaultResponse } from '../../models/DefaultResponse';
import { AtribuicoesPorUsuario, AutorizaGovBr, UserLoginSed } from '../../models/sed/UserLogin';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private api = ConvivaApi;
  private keyDecrypt = '1234-conviva';

  userLogado = signal<null | UserLoginSed>(null);

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
  }

  public hasTokenGovBr(): boolean {
    const userExist = localStorage.getItem("tokenGovBr");
    if (userExist == null)
      return false;
    else
      return true;
  }

  public getTokenGovBr(): string {
    const token = localStorage.getItem("tokenGovBr");
    if (token != null)
      return token;

    return "";
  }

  public setTokenGovBr(token: string) {
    localStorage.setItem("tokenGovBr", `Bearer ${token}`);
  }

  public cleanStorageGovBr() {
    localStorage.removeItem("tokenGovBr");
  }

  public hasTokenMasp(): boolean {
    const userExist = localStorage.getItem("tokenMasp");
    if (userExist == null)
      return false;
    else
      return true;
  }

  public getTokenMasp(): string {
    const token = localStorage.getItem("tokenMasp");
    if (token != null)
      return token;

    return "";
  }

  public setTokenMasp(token: string) {
    localStorage.setItem("tokenMasp", `Bearer ${token}`);
  }

  public cleanStorageMasp() {
    localStorage.removeItem("tokenMasp");
  }

  public hasTokenConviva(): boolean {
    const userExist = localStorage.getItem("tokenConviva");
    if (userExist == null)
      return false;
    else
      return true;
  }

  public getToken(): string {
    const token = localStorage.getItem("tokenConviva");
    if (token != null)
      return token;

    return "";
  }

  public setTokenConviva(token: string) {
    localStorage.setItem("tokenConviva", `${token}`);
  }

  public cleanStorageConviva() {
    localStorage.removeItem("tokenConviva");
    this.cleanStorageUserLogado();
  }

  public getTokenConviva(): Observable<DefaultResponse> {
    if (this.hasTokenMasp()) {
      const token = this.getTokenMasp();
      const headers = new HttpHeaders({ 'Authorization': token, 'Ocp-Apim-Subscription-Key': environment.ApimConviva });

      return this.http.get<DefaultResponse>(`${this.api.Login.getTokenSedMasp}`, { 'headers': headers })
        .pipe(map((response: DefaultResponse) => response));
    }

    const token = this.getTokenGovBr();

    const headers = new HttpHeaders({ 'Authorization': token, 'Ocp-Apim-Subscription-Key': environment.ApimConviva });

    return this.http.get<DefaultResponse>(`${this.api.Login.getTokenSed}`, { 'headers': headers })
      .pipe(map((response: DefaultResponse) => response));
  }

  public LoginSed(): Observable<AutorizaGovBr> {
    return this.http.post<AutorizaGovBr>(`${this.api.Sed.LoginSed}`, {})
      .pipe(map((response: AutorizaGovBr) => response));
  }

  public LoginMasp(): Observable<AutorizaGovBr> {
    return this.http.post<AutorizaGovBr>(`${this.api.Sed.LoginMasp}`, {})
      .pipe(map((response: AutorizaGovBr) => response));
  }

  public getAtribuicoesPerfil(cdUsuario: number, codigoPerfil: number): Observable<AtribuicoesPorUsuario> {
    const token = this.getTokenGovBr();
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': token, 'Ocp-Apim-Subscription-Key': environment.Apim });


    return this.http.get<AtribuicoesPorUsuario>(`${this.api.Sed.getUserProfileSed}/${cdUsuario}/${codigoPerfil}`, { headers: headers })
      .pipe(map((response: AtribuicoesPorUsuario) => response));
  }

  public setLoginAnalytics(
    codigoUsuario: number,
    nome: string,
    cpf: string,
    codigoPerfil: number,
    nomePerfil: string,
    numeroComportamento: string
  ): Observable<DefaultResponse> {

    const body = {
      codigoUsuario,
      nome,
      cpf,
      codigoPerfil,
      nomePerfil,
      numeroComportamento
    };

    return this.http.post<DefaultResponse>(
      this.api.Analytics.setLoginAnalytics,
      body
    );
  }

  public getUser(): UserLoginSed | null {
    const userEncrypted = localStorage.getItem("userLogado");
    if (userEncrypted != null) {
      try {
        const userDecrypted = CryptoJS.AES.decrypt(userEncrypted, this.keyDecrypt).toString(CryptoJS.enc.Utf8);
        this.userLogado.set(JSON.parse(userDecrypted) as UserLoginSed);
        return JSON.parse(userDecrypted) as UserLoginSed;
      }
      catch (error) {
        this.router.navigate(['/logout']);
      }
    }

    return null;
  }

  public setUser(userLogado: UserLoginSed) {
    this.userLogado.set(userLogado);
    const userLogadoEncrypted = CryptoJS.AES.encrypt(JSON.stringify(userLogado), this.keyDecrypt).toString();
    localStorage.setItem("userLogado", userLogadoEncrypted);
  }

  public cleanStorageUserLogado() {
    this.userLogado.set(null);
    localStorage.removeItem("userLogado");
  }

  public getEscolaDecrypt(): string | null {
    const escolaEncrypted = localStorage.getItem("codigoEscola");
    if (escolaEncrypted != null) {
      try {
        const escolaDecrypted = CryptoJS.AES.decrypt(escolaEncrypted, this.keyDecrypt).toString(CryptoJS.enc.Utf8);
        return escolaDecrypted;
      }
      catch (error) {
        return null;
      }
    }

    return null;
  }

  public getEscola(): string | null {
    return localStorage.getItem("codigoEscola") ?? null;
  }

  public setEscola(escola: number) {
    this.cleanStorageEscola();

    const escolaEncrypted = CryptoJS.AES.encrypt(JSON.stringify(escola), this.keyDecrypt).toString();
    localStorage.setItem("codigoEscola", escolaEncrypted);
  }

  public getDiretoriaDecrypt(): string | null {
    const diretoriaEncrypted = localStorage.getItem("codigoDiretoria");
    if (diretoriaEncrypted != null) {
      try {
        const diretoriaDecrypted = CryptoJS.AES.decrypt(diretoriaEncrypted, this.keyDecrypt).toString(CryptoJS.enc.Utf8);
        return diretoriaDecrypted;
      }
      catch (error) {
        return null;
      }
    }

    return null;
  }

  public getDiretoria(): string | null {
    return localStorage.getItem("codigoDiretoria") ?? null;
  }

  public setDiretoria(diretoria: number) {
    this.cleanStorageDiretoria();

    const diretoriaEncrypted = CryptoJS.AES.encrypt(JSON.stringify(diretoria), this.keyDecrypt).toString();
    localStorage.setItem("codigoDiretoria", diretoriaEncrypted);
  }

  private cleanStorageEscola() {
    localStorage.removeItem("codigoEscola");
  }

  private cleanStorageDiretoria() {
    localStorage.removeItem("codigoDiretoria");
  }
}
